import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {
  user$ = this.authService.getUser();
  showLogin = true;
  returnUrl: string | null = null;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  login(email: string, password: string) {
    this.authService.login(email, password)
      .then(() => this.redirectAfterAuth())
      .catch(err => alert('Login failed: ' + err.message));
  }

  logout() {
    this.authService.logout();
  }

  signup(email: string, password: string) {
    this.authService.signup(email, password)
      .then(() => this.redirectAfterAuth())
      .catch(err => alert('Signup failed: ' + err.message));
  }

  private redirectAfterAuth() {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    }
  }
}
